/* Harper & Stone — country / currency.
 *
 * Choosing a country submits Shopify's localization form at once; Shopify
 * switches the currency and brings the shopper back to the same page.
 * Delegated, so the footer's and the drawer's copies share one listener,
 * and a module, so loading it twice runs it once. */
document.addEventListener('change', (e) => {
  const select = e.target.closest?.('[data-hs-loc-country]');
  if (!select) return;
  select.form?.requestSubmit?.() ?? select.form?.submit();
});
